export enum ChartCustomHookNames {
  ChartLegendSelectChanged = 'legendselectchanged',
  ChartClick = 'click',
  ChartDataZoom = 'datazoom',
  ChartInit = 'init',
  ChartFinished = 'finished',
}
